import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type SupportState = {
	support: {
		requestProfile: string;
		providerMapping: string;
		workflowConfig: string;
	};
};

type SupportActions = {
	setRequestProfile: (requestProfile: Partial<SupportState['support']['requestProfile']>) => void;
	setProviderMapping: (providerMapping: Partial<SupportState['support']['providerMapping']>) => void;
	setWorkflowConfig: (workflowConfig: Partial<SupportState['support']['workflowConfig']>) => void;
};

export type SupportSlice = SupportState & SupportActions;

const supportInitialState: SupportState = {
	support: {
		requestProfile: '',
		providerMapping: '',
		workflowConfig: '',
	},
};

export function supportSlice(set: NamedSet<ZustandStore>): SupportSlice {
	return {
		...supportInitialState,
		setRequestProfile(requestProfile: Partial<SupportState['support']['requestProfile']>): void {
			set(
				(state: SupportState) => {
					state.support.requestProfile = requestProfile;
					return state;
				},
				false,
				'[setRequestProfile]',
			);
		},
		setProviderMapping(providerMapping: Partial<SupportState['support']['providerMapping']>): void {
			set(
				(state: SupportState) => {
					state.support.providerMapping = providerMapping;
					return state;
				},
				false,
				'[setProviderMapping]',
			);
		},
		setWorkflowConfig(workflowConfig: Partial<SupportState['support']['workflowConfig']>): void {
			set(
				(state: SupportState) => {
					state.support.workflowConfig = workflowConfig;
					return state;
				},
				false,
				'[setWorkflowConfig]',
			);
		},
	};
}
